module.exports = __webpack_public_path__ + "static/media/linha_colorida_mobile.c6930825.svg";